module.exports = __webpack_public_path__ + "img/slogan.30467aef.png";